import { Router } from "express";

import { quizReportController } from "../controllers/quiz-report-controller";
import {
  authenticate,
  requireEmailVerification,
} from "../middleware/auth-middleware";
import { requireRole } from "../middleware/role-middleware";
import {
  attachSchoolContext,
  requireSchoolContext,
} from "../middleware/school-context-middleware";

const router = Router();

/**
 * CLASS QUIZ REPORT ROUTES
 */

// Apply authentication and authorization
router.use(authenticate);
router.use(requireEmailVerification);
router.use(requireRole(["school", "teacher"]));
router.use(attachSchoolContext);

/**
 * @route   GET /api/v1/school/classes/:classId/quiz-report
 * @desc    Get quiz report for a specific class (all students' performance)
 * @access  Private (School Admin, Teacher)
 * @query   quizId (optional) - Filter by specific quiz
 */
router.get("/:classId/quiz-report", requireSchoolContext, (req, res) =>
  quizReportController.getClassQuizReport(req, res),
);

export default router;
